import { EditBase, Form, required } from "ra-core";
import { TextInput } from "@/components/admin/text-input";
import { SelectInput } from "@/components/admin/select-input";
import { NumberInput } from "@/components/admin/number-input";
import { Card, CardContent } from "@/components/ui/card";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

const sourceChoices = [
  { id: "website", name: "官网" }, { id: "referral", name: "客户推荐" },
  { id: "event", name: "市场活动" }, { id: "outbound", name: "主动开发" },
  { id: "partner", name: "合作伙伴" }, { id: "social", name: "社交媒体" }, { id: "other", name: "其他" },
];
const statusChoices = [
  { id: "new", name: "新建" }, { id: "working", name: "跟进中" },
  { id: "qualified", name: "已确认资格" }, { id: "nurture", name: "持续培育" },
  { id: "disqualified", name: "不合格" },
];

export const LeadEdit = () => <EditBase redirect="show" transform={(values) => {
  if (values.status === "converted") return values;
  return { ...values, converted_at: null, converted_account_id: null, converted_contact_id: null, converted_deal_id: null };
}}>
  <div className="mt-2 flex lg:mr-72"><div className="flex-1"><Form><Card><CardContent>
    <div className="orbitas-form-section"><h2>线索信息</h2><div className="grid gap-4 md:grid-cols-2">
      <TextInput source="first_name" label="名" /><TextInput source="last_name" label="姓" validate={required()} />
      <TextInput source="company_name" label="企业名称" validate={required()} /><TextInput source="title" label="职位" />
      <TextInput source="email" label="工作邮箱" type="email" /><TextInput source="phone" label="联系电话" />
      <TextInput source="website" label="企业网站" /><SelectInput source="source" label="线索来源" choices={sourceChoices} />
      <SelectInput source="status" label="线索状态" choices={statusChoices} />
      <SelectInput source="rating" label="线索评分" choices={[{id:"hot",name:"高"},{id:"warm",name:"中"},{id:"cold",name:"低"}]} />
      <TextInput source="industry" label="所属行业" /><TextInput source="country" label="国家/地区" />
      <TextInput source="state" label="省/州" /><TextInput source="city" label="城市" />
      <NumberInput source="annual_revenue" label="企业年收入（估算）" min={0} /><TextInput source="currency_code" label="币种（ISO 4217）" />
    </div><TextInput source="description" label="背景与需求" multiline rows={4} /></div>
    <div role="toolbar" className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-card to-10% flex-row justify-end gap-2"><CancelButton /><SaveButton label="保存修改" /></div>
  </CardContent></Card></Form></div></div>
</EditBase>;
